import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ValidatePermissionsService } from '../shared/services/validate-permissions.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard implements CanActivate {
  constructor(
    private router: Router,
    private permissionsService: ValidatePermissionsService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    let currentRoute = route;

    // Recorrer hacia abajo a través de las rutas hijas para encontrar la ruta más específica
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    //console.log('AuthorizationGuard');
    const functionality = currentRoute.data['functionality'] as number;
    const requiredAccessLevels = currentRoute.data['requiredAccessLevel'] as string[];

    // Asegura que el usuario esté autenticado primero
    const JWT = localStorage.getItem('JWT');
    const Code = localStorage.getItem('Code');
    // console.log('JWT: ' + JWT);
    // console.log('Code: ' + Code);
    // console.log('Funcionalidad: ' + functionality);
    // console.log('requiredAccessLevels: ' + requiredAccessLevels);
    if (JWT === null || Code === null) {
      this.handleUnauthorizedAccess(functionality);
      return false;
    } else {
      return this.permissionsService
//        .userHasPermission$(functionality, requiredAccessLevels)
        .loadPermissions$()
        .pipe(
          map((/*hasPermission*/) => {
            const hasPermission = this.permissionsService.userHasPermission(functionality, requiredAccessLevels);
            this.permissionsService.validateAccessLevels(functionality);
            if (!hasPermission) {
              if (functionality !== MODULE_ID.Home) {
                //console.log('Funcionalidad  diferente de 2 (MODULE_ID.Home)');
                this.router.navigate(['/home']);
                return false;
              } else {
                //console.log('Funcionalidad 2 (MODULE_ID.Home)');
                localStorage.clear();
                this.router.navigate(['/login']); // Navegar a home o a una página de "Acceso Denegado" según convenga
                return false;
              }
            }
            return true;
          }),
          catchError((error) => {
            // Manejar cualquier error que ocurra durante la verificación de permisos
            this.handleUnauthorizedAccess(functionality);
            return of(false); // Retorna un observable de false en caso de error
          })
        );
    }
  }

  private handleUnauthorizedAccess(functionality: number): void {
    // Lógica para manejar acceso no autorizado, como limpiar el almacenamiento local y redirigir al login
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
